// extracted by mini-css-extract-plugin
export default {"row":"Accordion-module__row__PBWmT","body":"Accordion-module__body__ISKN1"};